import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-base-200">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary">404</h1>
        <p className="text-2xl font-semibold mt-4">Page Not Found</p>
        <p className="text-base-content/60 mt-2">
          The page you're looking for doesn't exist.
        </p>
        <div className="mt-6">
          <Link to="/chat" className="btn btn-primary">
            Go to Chat
          </Link>
        </div>
      </div>
    </div>
  )
}